import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'PARAM_COMPT',
  title: 'Wie kann ich meine persönlichen Daten ändern?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Um Ihre persönlichen Daten zu ändern, klicken Sie auf das kleine Männchen unten links'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_PARAM_COMPT/DE_PARAM_COMPT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie dann auf "Mein Konto".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_PARAM_COMPT/DE_PARAM_COMPT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Sie können dann Ihre persönlichen Daten aktualisieren und bestätigen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_PARAM_COMPT/DE_PARAM_COMPT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Bitte beachten Sie aus Sicherheitsgründen, dass :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: '- Die Person mit der Rolle "Account Manager" kann nicht alle ihre persönlichen Daten ändern'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Dazu können sie eine Anfrage an den Kundendienst stellen.'
  }]
};
